import { Component } from 'react';
import { EERIE } from 'HubStyleTokens/colors';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import MultilineCharacterCounter from './MultilineCharacterCounter';
import { jsx as _jsx } from "react/jsx-runtime";
const SubtitleEditorContainer = styled.div.withConfig({
  displayName: "SubtitleEditor__SubtitleEditorContainer",
  componentId: "hntqyd-0"
})(["width:688px;margin:6px auto 0;"]);
const SubtitleFieldTextArea = styled(UIExpandingTextArea).attrs({
  className: 'article-subtitle-text'
}).withConfig({
  displayName: "SubtitleEditor__SubtitleFieldTextArea",
  componentId: "hntqyd-1"
})(["&&&&{padding:0;}&&::-webkit-input-placeholder{font-family:Helvetica-Light,sans-serif;font-size:1.5rem;font-weight:300;}"]);
const SubtitleFieldFormControl = styled(UIFormControl).withConfig({
  displayName: "SubtitleEditor__SubtitleFieldFormControl",
  componentId: "hntqyd-2"
})(["&:not(.kb-character-counter) > label{display:", ";color:", ";font-weight:400;margin-top:-6px;}"], props => props.showLabel ? 'initial' : 'none', EERIE);
const I18nKey = key => `knowledgeContentUI.edit.fields.subtitle.${key}`;
class SubtitleEditor extends Component {
  constructor(...args) {
    super(...args);
    this.preventDefaultEvent = e => {
      e.preventDefault();
    };
  }
  render() {
    return /*#__PURE__*/_jsx(SubtitleEditorContainer, {
      onDragEnter: this.preventDefaultEvent,
      onDragOver: this.preventDefaultEvent,
      onDrop: this.preventDefaultEvent,
      children: /*#__PURE__*/_jsx(SubtitleFieldFormControl
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      , {
        showLabel: !this.props.value,
        label: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: I18nKey('label_jsx'),
          elements: {
            Small
          }
        }),
        required: false,
        children: /*#__PURE__*/_jsx(MultilineCharacterCounter, {
          disabled: this.props.disabled,
          inputRef: this.props.inputRef,
          maxLength: 250,
          maxLengthWarningThreshold: 10,
          onChange: this.props.onChange,
          textAreaComponent: SubtitleFieldTextArea,
          placeholder: I18n.text(I18nKey('placeholder')),
          value: this.props.value
        })
      })
    });
  }
}
export default SubtitleEditor;